import Plus from '../../src/legacy/Plus.tsx';
export default Plus;
